import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Header {
    constructor() {
        this.$document = $(document);
        this.$window = $(window);
        this.$body = $('body');
        this.speed = 300;
        this.mobileBreakpoint = 1024;
        this.$main = $('main');
        this.$header = $('.js-header');
        this.$logo = $('.js-header-logo');
        this.headerHeight = this.$header.outerHeight(true);
        this.$content = $('.js-content');

        // Search
        this.$searchWrapper = $('.js-search-wrapper');
        this.$searchForm = $('.js-search-form');
        this.$searchField = $('.js-search-field');
        this.$searchOpenButton = $('.js-search-open');
        this.$searchCloseButton = $('.js-search-close');

        // Menu
        this.$mainMenu = $('.js-main-menu');

        // Burger Menu
        this.$burgerButton = $('.js-burger-button');
        this.$burgerContent = $('.js-burger-content');
        this.$subMenus = $('.js-sub-menu');

        // Mobile Menu
        this.$chevrons = $('.js-menu-chevron');
        this.$menuItemExpandButton = $('.js-menu-item-expand');

        // -------

        // Submenu Events
        this.$menuItemExpandButton.on('click', $.proxy(this.toggleMenu, this));

        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));
        this.$searchCloseButton.on('click', $.proxy(this.closeSearch, this));

        // Close search on doc click
        this.$document.on('click', $.proxy(this.documentClick, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
            }
        });

        // General sticky header
        this.$window.on('scroll', () => {
            this.stickyHeader();
        });

        // Burger Events
        this.$burgerButton.on('click', $.proxy(this.burgerToggle, this));

        // Mobile Menu Events
        this.$chevrons.on('click', $.proxy(this.toggleMenu, this));

        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
                this.destroyScrollbars();
            } else {
                this.addScrollbars();
            }
        }, 300)).on('load', () => {
            if (this.$window.width() <= this.mobileBreakpoint) {
                this.addScrollbars();
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];
    }

    addScrollbars() {
        this.scrollbars.push(new Ps(this.$burgerContent[0]));
    }

    destroyScrollbars() {
        this.scrollbars.forEach((ps) => ps.destroy());
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());
    }

    /*
        documentClick(e) {
            const $elem = $(e.target);

            if (!$elem.closest(this.$searchForm).length && !$elem.closest(this.$searchOpenButton).length) {
                this.closeSearch();
            }
        }

     */

    closeSearch(e) {
        if (typeof e !== 'undefined') {
            e.preventDefault();
        }

        this.$searchForm.fadeTo(this.speed, 0, () => {
            this.$mainMenu.removeClass('search-is-open');
            this.$searchWrapper.removeClass('is-open');
            this.$searchOpenButton.fadeTo(this.speed, 1);
        });
    }

    openSearch() {
        this.$mainMenu.addClass('search-is-open');
        this.$searchWrapper.addClass('is-open');
        this.$searchOpenButton.fadeTo(this.speed, 0);

        this.$searchForm.fadeTo(this.speed, 1, () => {
            this.$searchField.focus();
        });
    }

    toggleMenu(e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');
        $elem.parent().next().slideToggle(this.speed, () => {
            this.updateScrollbars();
        });
    }

    burgerToggle() {
        let headerToggled = false;

        this.$burgerButton.toggleClass('is-open');

        if (!this.$header.hasClass('is-open') && !headerToggled) {
            this.$header.toggleClass('is-open');
            headerToggled = true;
        }

        this.$burgerContent.slideToggle(this.speed, () => {
            this.updateScrollbars();

            if (this.$header.hasClass('is-open') && !headerToggled) {
                this.$header.toggleClass('is-open');
                headerToggled = true;
            }
        });

        // this.$burgerButton.text(function(i, text) {
        // return text === 'CLOSE' ? 'MENU' : 'CLOSE';
        // });

        $('body').toggleClass('is-scroll-locked');
    }

    stickyHeader() {
        if (this.$content.length) {
            // Check if the page is using the WordPress admin bar. If it is, take the height of it away from the scrollTop to prevent jumpiness
            let windowScrollTop;
            if (this.$body.hasClass('admin-bar')) {
                windowScrollTop = this.$window.scrollTop() - 32;
            } else {
                windowScrollTop = this.$window.scrollTop();
            }
            if (windowScrollTop > 56) {
                if (!this.$header.hasClass('is-sticky')) {
                    // Add class and negative top position to snap the sticky header out of view (64px is the height of the sticky header)
                    // this.$header.addClass('is-sticky').css('top', '-145px');
                    this.$header.addClass('is-sticky');
                    this.$mainMenu.addClass('is-small');
                    // Reset the top position to 0 after the length of the sticky animation so it scrolls in and out of view properly
                    /*
                    setTimeout(() => {
                        this.$logo.addClass('is-hidden');
                    }, 600);
                    */
                    // this.$content.css('paddingTop', this.headerHeight);
                }
            } else {
                this.$header.removeClass('is-sticky');
                this.$mainMenu.removeClass('is-small');
                // this.$logo.removeClass('is-hidden');
                // this.$content.css('paddingTop', 0);
            }

            // if (windowScrollTop > (this.headerHeight + this.headerHeight)) {
            // if (!this.$header.hasClass('sticky-is-visible')) {
            // this.$header.addClass('sticky-is-visible').css('top', 0);
            // }
            // }
            // else {
            // this.$header.removeClass('sticky-is-visible');
            // }
        }
    }

    resetEverything() {
        // Close
        this.closeSearch();

        // Reset Burger Menu
        this.$header.removeClass('is-open');
        this.$burgerButton.removeClass('is-open');
        this.$burgerContent.removeAttr('style');
        this.$subMenus.removeAttr('style');

        $('body').removeClass('is-scroll-locked');
    }

}

export default Header;
